import { render } from "./LinkButton.vue?vue&type=template&id=ec45df36&scoped=true&ts=true"
import script from "./LinkButton.vue?vue&type=script&lang=ts"
export * from "./LinkButton.vue?vue&type=script&lang=ts"

import "./LinkButton.vue?vue&type=style&index=0&id=ec45df36&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ec45df36"]])

export default __exports__